import { type ReactNode } from 'react';
import type { Editor } from '@tiptap/react';
import { ToolButton } from './tiptap-tool-button';
import {
  type Item,
  markItems,
  headingItems,
  blockItems,
} from './tiptap-toolbar-items';

type Props = { editor: Editor | null };

function Group({ items }: { items: Item[] }): ReactNode {
  return (
    <>
      {items.map((it) => (
        <ToolButton
          key={it.title}
          active={it.active}
          onClick={it.onClick}
          title={it.title}
        >
          {it.icon}
        </ToolButton>
      ))}
    </>
  );
}

const SEP = <span className="mx-xs h-4 w-px bg-white/[0.06]" />;
const ROW =
  'flex flex-wrap items-center gap-xs border-b border-white/[0.06] px-sm py-xs';

export function TiptapToolbar({ editor }: Props): ReactNode {
  if (!editor) return null;
  return (
    <div className={ROW}>
      <Group items={markItems(editor)} />
      {SEP}
      <Group items={headingItems(editor)} />
      {SEP}
      <Group items={blockItems(editor)} />
    </div>
  );
}
